import React, { useEffect } from "react";
import "./notification.css";
import help from "../../../img/undraw_opened_re_i38e.svg";
import { Fade } from "react-awesome-reveal";
import {
  Autocomplete,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateUserDashboardNotifiactionAction,
  getUserAndSubuserAction,
} from "../../../redux/actions/ManageAdminAction";
import notify from "../../Notifcation";
import { Spinner } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
const filter = createFilterOptions();
const NotificationsAdmin = () => {
  const [Mainacc, setMainacc] = useState("");
  const [Messagee, setMessage] = useState("");
  // const [Phone, setPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const dispatch = useDispatch();
  const userAndsubuser = useSelector(
    (state) => state.ManageAdminR.UserAndSubuser
  );
  const res = useSelector((state) => state.ManageAdminR.CreateNotification);

  useEffect(() => {
    dispatch(getUserAndSubuserAction(`PageSize=${50000}`));
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Mainacc === null || Messagee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      CreateUserDashboardNotifiactionAction({
        userId: Mainacc ? Mainacc.id : null,
        message: Messagee,
      })
    );
    setLoading(false);
    setIsPress(false);
    setMessage("");
    setMainacc("");
    // setPhone("");
  };
  useEffect(() => {
    if (loading === false) {
      if (res && res.data) {
        if (
          res.data.responseMessage ===
          "Great, The Notification created Successfully"
        ) {
          notify("تم أرسال الرسالة بنجاح", "success");
        }
      } else {
        notify("الرجاء حاول مرة اخرى", "error");
      }
    }
  }, [loading, res]);
  return (
    <div className="Noti">
      <div className="container rounded bg-white mt-5 mb-5">
        <div className="row">
          <h4 className="text-center">إدارة الأشعارات</h4>
          <div className="col-md-6 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3"></div>
              <div className="row mt-3">
                <div className="col-md-12 de mb-2">
                  {" "}
                  <Autocomplete
                    value={Mainacc}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setMainacc({
                          Name: newValue,
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setMainacc({
                          Name: newValue.inputValue,
                        });
                      } else {
                        setMainacc(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.name
                      );
                      if (inputValue !== "" && !isExisting) {
                        filtered.push({
                          inputValue,
                          // name: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={
                      userAndsubuser &&
                      userAndsubuser.data &&
                      userAndsubuser.data.data.length >= 0
                        ? userAndsubuser.data.data
                        : []
                    }
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.phoneNumber;
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.Id}>
                        {option.phoneNumber}
                      </li>
                    )}
                    sx={{ width: 300 }}
                    freeSolo
                    renderInput={(params) => (
                      <TextField {...params} label="رقم الهاتف" />
                    )}
                  />
                </div>
                <div className="col-md-12 de mb-2">
                  {" "}
                  <TextField
                    label="أسم المستخدم"
                    variant="outlined"
                    value={Mainacc ? Mainacc.name : ""}
                    // onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <div className="col-md-12 de are">
                  {" "}
                  <TextField
                    multiline
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        الرسالة
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    value={Messagee}
                    onChange={(e) => setMessage(e.target.value)}
                    inputProps={{ maxLength: 120 }}
                  />
                </div>
              </div>
              <div className="mt-5 text-center">
                {isPress && loading ? (
                  <button className="buttonadd profile-button" type="button">
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                ) : (
                  <button
                    className="buttonadd"
                    type="button"
                    onClick={handlesubmit}>
                    إرسال
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={1200} />
    </div>
  );
};
export default NotificationsAdmin;
